import React, { useEffect, useState } from 'react';
import Image1 from '../assets/images/Dunlop.jpg';
import Image2 from '../assets/images/Al-Baz.png';
import Image3 from '../assets/images/hclogo.png';
import Image4 from '../assets/images/Hamdan-Exchange-logo.jpg';
import Image5 from '../assets/images/HMI_Logo.jpg';
import Image6 from '../assets/images/Hamdan-Transport.png';
import Image7 from '../assets/images/HTTA_LOGO2.png';
import Image8 from '../assets/images/HPH-logo.jpg';

const MarqueeCarousel: React.FC = () => {
  const [images, setImages] = useState<string[]>([]);

  useEffect(() => {
    fetch('/api/homepage/content')
      .then(res => res.json())
      .then(data => {
        const groupData = data.Group || {};
        const fetched = [];
        for (let i = 1; i <= 8; i++) {
          if (groupData[`logo_${i}_image`]) fetched.push(groupData[`logo_${i}_image`]);
        }
        setImages(fetched.length > 0 ? fetched : [Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8]);
      })
      .catch(err => {
        console.warn('Group logos unavailable:', err);
        setImages([Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8]);
      });
  }, []);

  const duplicated = [...images, ...images];

  return (
    <div className="overflow-hidden w-full bg-white py-0">
      <div className="relative w-[200%] flex animate-marquee space-x-20 items-center">
        {duplicated.map((img, index) => (
          <div key={index} className="flex-shrink-0">
            <img src={img} alt="company" className="h-20 w-auto object-contain min-w-[100px]" />
          </div>
        ))}
      </div>
      <style>{`
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .animate-marquee { animation: marquee 35s linear infinite; }
      `}</style>
    </div>
  );
};

export default MarqueeCarousel;
